/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ChildBabyIcon16Light } from './ChildBabyIcon16Light';
import { ChildBabyIcon16Regular } from './ChildBabyIcon16Regular';
import { ChildBabyIcon16Solid } from './ChildBabyIcon16Solid';
import { ChildBabyIcon20Light } from './ChildBabyIcon20Light';
import { ChildBabyIcon20Regular } from './ChildBabyIcon20Regular';
import { ChildBabyIcon20Solid } from './ChildBabyIcon20Solid';
import { ChildBabyIcon24Regular } from './ChildBabyIcon24Regular';
import { ChildBabyIcon24Solid } from './ChildBabyIcon24Solid';
import { ChildBabyIcon32Regular } from './ChildBabyIcon32Regular';
import { ChildBabyIcon64Regular } from './ChildBabyIcon64Regular';
var sizes = {
    16: {
        light: ChildBabyIcon16Light,
        regular: ChildBabyIcon16Regular,
        solid: ChildBabyIcon16Solid,
    },
    20: {
        light: ChildBabyIcon20Light,
        regular: ChildBabyIcon20Regular,
        solid: ChildBabyIcon20Solid,
    },
    24: {
        regular: ChildBabyIcon24Regular,
        solid: ChildBabyIcon24Solid,
    },
    32: {
        regular: ChildBabyIcon32Regular,
    },
    64: {
        regular: ChildBabyIcon64Regular,
    },
};
export var ChildBabyIcon = forwardRef('ChildBabyIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
